module.exports = __webpack_public_path__ + "img/10.851d6897.png";